import React from 'react';

const SearchBar = ({ onSearch }) => {
    return (
        <input
            type="text"
            className="search-input"
            placeholder="Search for a question in notebook..."
            onChange={e => onSearch(e.target.value)}
        />
    );
};

export default SearchBar;
